import React, { useState, useEffect, useRef } from "react";
import { useAppSelector } from "../../redux/typedHooks";
import type { UserInterface } from "../../types/user";
import DeletedPostModal from "./DeletedPostModal";
import { getFirstUnviewedDeletedCommentAPI, getFirstUnviewedDeletedPostAPI } from "../../api/userApi";
import DeletedCommentModal from "./DeletedCommentModal";

const DeletedPostModalManager: React.FC = () => {
  const [showPostModal, setShowPostModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const hasCheckedRef = useRef(false);
  const user = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );

  useEffect(() => {
    // Check if user is logged in and check for unviewed posts
    if (user && !hasCheckedRef.current) {
      hasCheckedRef.current = true;
      // Check for unviewed deleted post immediately
      (async () => {
        try {
          // Спочатку перевіряємо пости
          const postResponse = await getFirstUnviewedDeletedPostAPI();
          if (postResponse.success && postResponse.data) {
            setShowPostModal(true);
            return; // показуємо пост, коментарі перевіримо після закриття
          }

          // Якщо постів немає — перевіряємо коментарі
          const commentResponse = await getFirstUnviewedDeletedCommentAPI();
          if (commentResponse.success && commentResponse.data) {
            setShowCommentModal(true);
          }
        } catch (error) {
          // Silently fail - no unviewed posts or error
          console.log("No unviewed deleted posts");
        }
      })();
    } else if (!user) {
      hasCheckedRef.current = false;
      setShowPostModal(false);
      setShowCommentModal(false);
    }
  }, [user]);


  const handleClosePost = () => {
    setShowPostModal(false);
    // після закриття поста можна перевірити коментарі
    (async () => {
      try {
        const commentResponse = await getFirstUnviewedDeletedCommentAPI();
        if (commentResponse.success && commentResponse.data) {
          setShowCommentModal(true);
        }
      } catch (error) {
        console.log("No unviewed deleted comments");
      }
    })();
  };

  const handleCloseComment = () => {
    setShowCommentModal(false);
  };

  return (
    <>
      <DeletedPostModal open={showPostModal} onClose={handleClosePost} />
      <DeletedCommentModal open={showCommentModal} onClose={handleCloseComment} />
    </>
  );
};

export default DeletedPostModalManager;
